export enum DaDataEndpoints {
  ListCitiesByEntry = 'ListCitiesByEntry',
}

export interface ModelCitySuggestion {
  Id: string;
  Country: string | null;
  Region: string | null;
  City: string | null;
}

// ListCitiesByEntry вызывается на регистрации — до авторизации, поэтому
// необязательный в swagger ActiveBranchId не передаётся.
export interface ListCitiesByEntryRequest {
  searchStr: string;
}

export type ListCitiesByEntryResponse = ModelCitySuggestion[];
